/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { IntlProvider } from 'react-intl';
import _ from 'lodash';
import deepForceUpdate from 'react-deep-force-update';

import listLocaleSelector from 'redux/reduxStore/lists/listLocale';
import localeSelector from 'redux/reduxStore/locale';
import userSelector from 'redux/reduxStore/user';

import localeActions from 'redux/actions/locale';

function mapStateToProps(state) {
  const defaultLocaleId = listLocaleSelector.getClosestMatchingLocaleId(state, localeSelector.getClientLocales(state));
  const userLocaleId = userSelector.getLocaleId(state);
  const localeId = userLocaleId > 0 ? userLocaleId : defaultLocaleId;
  const localeData = listLocaleSelector.getLocale(state, localeId);
  const languageCode = localeData.language_code;

  return {
    languageCode,
    localeData,
    messages: localeSelector.getMessages(state, languageCode),
    localeList: listLocaleSelector.getCollection(state),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getInitialData: () => {
      // dispatch(listLocaleActions.request());
    },
    setLocale: (localeData) => {
      dispatch(localeActions.setCurrentLocale(localeData));
    },
  };
}

class ConnectedIntlProvider extends React.Component {

  UNSAFE_componentWillMount() {
    this.props.getInitialData();
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.localeList.length === 0) { return; }

    const updatingLocale = this.props.localeList.length === 0 || nextProps.languageCode !== this.props.languageCode;

    if (updatingLocale) {
      this.props.setLocale(nextProps.localeData);

      // React-Intl stores locale in the React context. Thus, there's no easy way
      // for descendant components to get notified of locale change.
      // One possible way would be to pass locale as key to IntlProvider,
      // but that will make component tree re-mount on each locale change with loosing any component state.
      // Instead, here we force component tree to repaint itself, which is a possible way to handle this particular scenario,
      // see https://github.com/facebook/react/issues/2517
      if (this.childRef) {
        deepForceUpdate(this.childRef);
      }
    }
  }

  render() {
    const { languageCode, messages } = this.props;
    const messageLength = _.keys(messages).length;
    if (!languageCode || messageLength === 0) { return null; }

    return (
      <IntlProvider
        locale={languageCode}
        messages={messages}
        defaultLocale="en"
        ref={ref => this.childRef = ref}
      >
        {this.props.children}
      </IntlProvider>
    );
  }
}
ConnectedIntlProvider.propTypes = {
  children: PropTypes.any,
  languageCode: PropTypes.string,
  messages: PropTypes.object,
  setLocale: PropTypes.func,
  getInitialData: PropTypes.func,
  localeList: PropTypes.array,
  localeData: PropTypes.object,
};

export default connect(mapStateToProps, mapDispatchToProps)(ConnectedIntlProvider);
